import { Box, Button, Card, IconButton, Typography } from '@mui/material';
import React from 'react';
import Webcam from 'react-webcam';
import { ReactComponent as TakePhotoIcon } from '../../assets/icons/CaptureFrame.svg';

import { ReactComponent as Check } from '../../assets/icons/Frame.svg';
import { ReactComponent as Trash } from '../../assets/icons/Trash.svg';
import { ReactComponent as Close } from '../../assets/icons/Vector.svg';

import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import useCandidate from '@authentication/hooks/useCandidate';
import { dataURItoBlob } from '@/utils';
import { uploadImage } from '@services/uploadCvVideo';
import { BackendUrl } from '@/utils/const';
import useCandidateId from '@/hooks/CandidateIdHook';
import { Photo } from '@authentication/contexts/candidateContext';
import usePhotoIsTacked from '@/hooks/PhotoTakedHook';

function TakePhoto() {
  const navigation = useNavigate();
  const { setPhotos, photos, handleDeletePhoto } = useCandidate();
  const candidateId = useCandidateId();
  const [, handlePhotTacked] = usePhotoIsTacked();

  const [photoUrl, setPhotoUrl] = React.useState('');
  const [srcPhoto, setSrcPhoto] = React.useState('');
  const [enableCam, setEnableCam] = React.useState(true);
  const webcamRef = React.useRef<Webcam>(null);

  const videoConstraints = {
    facingMode: 'user',
  };

  const handleTakePhoto = React.useCallback(async () => {
    const photoSrc = webcamRef.current?.getScreenshot();

    if (photoSrc) {
      setSrcPhoto(photoSrc);

      setPhotoUrl(photoSrc);
      if (candidateId)
        setPhotos((prev: any) => [
          ...prev,
          {
            selected: true,
            picked: true,
            id: 6,
            url: `${BackendUrl}/uploads/candidate_${candidateId}/photo.png`,
          },
        ]);
      setEnableCam(false);
    }
    handlePhotTacked();
  }, [webcamRef]);

  const handleRemovePhoto = () => {
    setPhotoUrl('');
    const idPhotoTaked = photos.find((photo: any) => photo.picked)?.id;
    if (idPhotoTaked) handleDeletePhoto(idPhotoTaked);
    setEnableCam(true);
  };
  const handleNavigation = async () => {
    const blob = dataURItoBlob(srcPhoto);
    await uploadImage(blob, 'photo.png', candidateId);
    setPhotos((prev: any) => [
      ...prev,
      {
        selected: true,
        picked: true,
        id: 6,
        url: `${BackendUrl}/uploads/candidate_${candidateId}/photo.png`,
      },
    ]);
    setPhotos((prev: any) => {
      console.log('====================================');
      console.log('prev', prev);
      console.log('====================================');
      const updatedPhotos = prev.map((photo: Photo) => ({
        ...photo,
        selected: !!photo.picked,
      }));

      return updatedPhotos;
    });

    navigation(Paths.ChoosePhotosPage);
  };
  const handleClose = () => {
    navigation(Paths.ChoosePhotosPage);
  };
  return (
    <Box
      sx={{
        maxWidth: '65rem',
        margin: '0',
      }}
    >
      {enableCam && (
        <Box sx={{ position: 'relative', width: '100vw' }}>
          <Webcam
            ref={webcamRef}
            width="100%"
            style={{
              height: '95dvh',
              width: '100%',
              position: 'relative',
              objectFit: 'cover',
            }}
            audio={false}
            videoConstraints={videoConstraints}
          />

          <Card
            onClick={handleClose}
            sx={{
              position: 'absolute',
              width: '48px',
              height: '48px',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '50%',
              display: 'flex',
              top: '2.5rem',
              left: '2.5rem',
              background: '#FFF7FC',
            }}
          >
            <Close />
          </Card>
          <Card
            onClick={handleTakePhoto}
            sx={{
              background: 'white',
              height: '100px',
              width: '100px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              marginBottom: '10px',
              left: '50%',
              bottom: '66px',
            }}
          >
            <TakePhotoIcon />
          </Card>
        </Box>
      )}
      {photoUrl && (
        <Box sx={{ position: 'absolute', width: '100vw' }}>
          <Box>
            <img
              src={photoUrl}
              style={{
                height: '95dvh',
                width: '100%',
                position: 'relative',
                objectFit: 'cover',
              }}
            />
          </Box>
          <Box sx={{ position: 'absolute', bottom: '66px', left: '50%' }}>
            <Button
              onClick={handleNavigation}
              sx={{
                background: '#3AA05C',
                width: '232px',
                height: '72px',
                borderRadius: '56px',
                boxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.48)',
                '&:hover': {
                  transform: 'scale(1.05)',
                  background: '#3AA05C',
                },
              }}
            >
              <Check />
              <Typography
                sx={{
                  color: '#FEFEFE',
                  fontFamily: 'Inter',
                  fontSize: '24px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: '36px',
                  textTransform: 'initial',
                  marginLeft: '12px',
                }}
              >
                Utiliser
              </Typography>
            </Button>
            <IconButton
              onClick={handleRemovePhoto}
              sx={{
                position: 'relative',
                width: '48px',
                height: '48px',
                background: '#B44058;',
                marginLeft: '24px',
              }}
            >
              <Trash />
            </IconButton>
          </Box>
          <Card
            onClick={handleClose}
            sx={{
              position: 'absolute',
              width: '48px',
              height: '48px',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '50%',
              display: 'flex',
              top: '34px',
              left: '2.5rem',
              background: '#FFF7FC',
            }}
          >
            <Close />
          </Card>
        </Box>
      )}
    </Box>
  );
}

export default TakePhoto;
